var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { CardButton, DeleteButton, DragHandle, EditButton, Overlay, OverlayInner } from './styles';
import { useDispatch } from 'react-redux';
import { toggleLongReadPostUpdate } from '../../../../../actions/toggleLRPostUpdate';
import { deleteLongReadPost } from '../../../../../actions/deleteLongReadPost';
import { getGalllleryUrl } from '../../../../../actions/getGalllleryUrl';
import { HintTooltip } from '@brg/ui';
import useLocalization from '../../../../../hooks/useLocalization';
import useCommonProps from '../../../../../hooks/useCommonProps';
var EditorOverlay = function (_a) {
    var _b = _a.post, postId = _b.postId, userId = _b.userId, style = _b.style, cardId = _b.cardId, dragHandleProps = _a.dragHandleProps, isTextBlock = _a.isTextBlock, withoutDrag = _a.withoutDrag, withoutDelete = _a.withoutDelete, withoutEdit = _a.withoutEdit, rowIcons = _a.rowIcons, toggleMobileEditor = _a.toggleMobileEditor, onCustomDelete = _a.onCustomDelete;
    var dispatch = useDispatch();
    var t = useLocalization().t;
    var _c = useCommonProps(), longreadId = _c.longreadId, sign = _c.sign;
    var handleEditClick = function () {
        dispatch(toggleLongReadPostUpdate(postId, true, longreadId));
        toggleMobileEditor && toggleMobileEditor(true);
    };
    var handleCardClick = function () {
        window.open(getGalllleryUrl() + '/collection/' + userId + '?card=' + cardId, '_blank');
    };
    var handleDeleteClick = function () {
        if (!window.confirm(t('confirmation.longread_block_delete')))
            return;
        if (onCustomDelete) {
            onCustomDelete();
            dispatch(deleteLongReadPost(postId, userId, longreadId, sign));
            return;
        }
        dispatch(deleteLongReadPost(postId, userId, longreadId, sign));
    };
    var isEditable = !['video', 'audio'].includes(style);
    return (React.createElement(Overlay, { static: isTextBlock },
        React.createElement(OverlayInner, { static: isTextBlock },
            !withoutDrag ? (React.createElement(DragHandle, __assign({}, dragHandleProps),
                React.createElement(HintTooltip, { h: '24px', w: '24px', text: t('hint.move'), noDisappearDelay: true }))) : (React.createElement("div", null)),
            React.createElement("div", { id: "edit-".concat(postId) },
                !withoutEdit && isEditable && (React.createElement(EditButton, { onClick: handleEditClick },
                    React.createElement(HintTooltip, { h: '24px', w: '24px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.edit'), noDisappearDelay: true }))),
                cardId && React.createElement(CardButton, { onClick: handleCardClick }),
                !withoutDelete && (React.createElement(DeleteButton, { onClick: handleDeleteClick },
                    React.createElement(HintTooltip, { h: '24px', w: '24px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.delete'), noDisappearDelay: true })))))));
};
export default EditorOverlay;
//# sourceMappingURL=EditorOverlay.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { CardButton, DeleteButton, DragHandle, EditButton, Overlay, OverlayInner } from './styles';
import { useDispatch } from 'react-redux';
import { toggleLongReadPostUpdate } from '../../../../../actions/toggleLRPostUpdate';
import { deleteLongReadPost } from '../../../../../actions/deleteLongReadPost';
import { getGalllleryUrl } from '../../../../../actions/getGalllleryUrl';
import { HintTooltip } from '@brg/ui';
import useLocalization from '../../../../../hooks/useLocalization';
import useCommonProps from '../../../../../hooks/useCommonProps';
var EditorOverlay = function (_a) {
    var _b = _a.post, postId = _b.postId, userId = _b.userId, style = _b.style, cardId = _b.cardId, dragHandleProps = _a.dragHandleProps, isTextBlock = _a.isTextBlock, withoutDrag = _a.withoutDrag, withoutDelete = _a.withoutDelete, withoutEdit = _a.withoutEdit, rowIcons = _a.rowIcons, toggleMobileEditor = _a.toggleMobileEditor, onCustomDelete = _a.onCustomDelete;
    var dispatch = useDispatch();
    var t = useLocalization().t;
    var _c = useCommonProps(), longreadId = _c.longreadId, sign = _c.sign;
    var handleEditClick = function () {
        dispatch(toggleLongReadPostUpdate(postId, true, longreadId));
        toggleMobileEditor && toggleMobileEditor(true);
    };
    var handleCardClick = function () {
        window.open(getGalllleryUrl() + '/collection/' + userId + '?card=' + cardId, '_blank');
    };
    var handleDeleteClick = function () {
        if (!window.confirm(t('confirmation.longread_block_delete')))
            return;
        if (onCustomDelete) {
            onCustomDelete();
            dispatch(deleteLongReadPost(postId, userId, longreadId, sign));
            return;
        }
        dispatch(deleteLongReadPost(postId, userId, longreadId, sign));
    };
    var isEditable = !['video', 'audio'].includes(style);
    return (React.createElement(Overlay, { static: isTextBlock },
        React.createElement(OverlayInner, { static: isTextBlock },
            !withoutDrag ? (React.createElement(DragHandle, __assign({}, dragHandleProps),
                React.createElement(HintTooltip, { h: '24px', w: '24px', text: t('hint.move'), noDisappearDelay: true }))) : (React.createElement("div", null)),
            React.createElement("div", { id: "edit-".concat(postId) },
                !withoutEdit && isEditable && (React.createElement(EditButton, { onClick: handleEditClick },
                    React.createElement(HintTooltip, { h: '24px', w: '24px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.edit'), noDisappearDelay: true }))),
                cardId && React.createElement(CardButton, { onClick: handleCardClick }),
                !withoutDelete && (React.createElement(DeleteButton, { onClick: handleDeleteClick },
                    React.createElement(HintTooltip, { h: '24px', w: '24px', closeToRightCorner: true, positionY: 'bottom', noArrow: true, text: t('hint.delete'), noDisappearDelay: true })))))));
};
export default EditorOverlay;
//# sourceMappingURL=EditorOverlay.js.map